<template>
  <div class="app-container">
    <!-- 工具栏 -->
    <div class="filter-container">
      <el-button size="mini" class="filter-item" type="danger" disabled>批量删除</el-button>
    </div>
    <el-table :header-cell-style="{background:'#eef1f6',color:'#606266',fontSize:'12px'}" border v-loading="listLoading" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
      @selection-change="handleSelectionChange" height="500px">

      <el-table-column type="selection" width="55"></el-table-column>

      <el-table-column label="编号" prop="ordinalPosition" width="100">
      </el-table-column>

      <el-table-column label="字段名" prop="columnName" min-width="100">
      </el-table-column>

      <el-table-column label="类型(长度)" prop="columnType" min-width="100">
      </el-table-column>

      <el-table-column label="主键" prop="columnKeyName" min-width="100">
      </el-table-column>

      <el-table-column label="说明" min-width="150">
        <template slot-scope="scope">
          <el-tooltip placement="top">
            <div slot="content">{{scope.row.columnComment}}</div>
            <div>{{ scope.row.columnComment | neirongsuojian }}</div>
          </el-tooltip>
        </template>
      </el-table-column>

      <!-- 操作 -->
      <el-table-column label="操作" width="160px" class-name="small-padding fixed-width" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" style="padding: 4px 15px;" type="primary" disabled>编辑</el-button>
          <el-button size="mini" style="padding: 4px 15px;" type="danger" disabled>删除</el-button>
        </template>
      </el-table-column>

    </el-table>

    <!-- 说明详细信息 并且可以复制 -->
    <copy-dialog ref="copyDialog"></copy-dialog>

  </div>
</template>

<script>
import { ajax_middleTableCofig } from '@Sys~/api/sys'
import CopyDialog from '../copyDialog'
export default {
  props: {
    tableName: {
      type: String,
      default: ''
    }
  },
  filters: {
    neirongsuojian(value) {
      if (value != "") {
        if (value.length > 20) {
          return value.substring(0, 20) + "...";
        } else {
          return value
        }
      } else {
        return ""
      }
    },
  },
  components: { CopyDialog },

  data() {
    return {
      listLoading: false,
      tableData: [],
      multipleSelection: [], // 已选数据

      infoDialog: false,
      jsontext: ''
    }
  },

  created() {
    this.getList()
  },

  methods: {
    // 获取数据
    getList() {
      this.listLoading = true
      ajax_middleTableCofig(this.tableName).then(response => {
        if (response.code == 1) {
          this.tableData = response.data
          this.listLoading = false
        } else {
          this.listLoading = false
        }
      })
    },

    // 全选
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection)
    },

    // 打开 并复制
    openCopy(row) {
      this.$refs['copyDialog'].init(row)
    }
  }
}
</script>

<style lang="scss" scoped>
.link {
  color: #646cf5;
  cursor: pointer;
}
</style>